module.exports = __webpack_public_path__ + "static/img/BELMONT-OAK.c3ebdf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/BELMONT-OAK.png
// module id = FRn4
// module chunks = 0